import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex items-center gap-2 flex-wrap text-xs text-foreground-500">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={`${item.label}-${idx}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800 font-medium" : ""}>{item.label}</span>
              )}
              {!isLast && (
                <span className="w-3.5 h-3.5 flex items-center justify-center text-foreground-300">
                  <i className="ri-arrow-right-s-line" />
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;